import type { Route } from 'next'

export const MOBILE_NAV: {
  title: string
  items: { href: Route; label: string }[]
}[] = [
  {
    title: '쇼핑',
    items: [
      { href: '/vehicles', label: '차종별 상품' },
      { href: '/products', label: '전체상품' },
      { href: '/products?tag=best' as Route, label: '베스트' },
      { href: '/products?tag=new' as Route, label: '신상품' },
    ],
  },
  {
    title: '상품군',
    items: [
      { href: '/products?code=charge-cover' as Route, label: '충전구 커버' },
      { href: '/products?code=slow-cover' as Route, label: '완속 충전구 커버' },
      { href: '/products?code=port-flap' as Route, label: '충전포트 플랩' },
      { href: '/products?group=interior' as Route, label: '인테리어·편의' },
    ],
  },
  {
    title: '안내',
    items: [
      { href: '/brand', label: '브랜드스토리' },
      { href: '/guide', label: '설치·사용 가이드' },
      { href: '/support', label: '자주 묻는 질문' },
      { href: '/support/delivery' as Route, label: '배송·교환 안내' },
      { href: '/support/inquiry' as Route, label: '1:1 문의' },
      { href: '/orders/lookup', label: '비회원 주문조회' },
    ],
  },
]
